import { useContext } from 'react'

import { Context } from './store/Context'
import wordmark from './images/shangyu-wordmark.png'
import './Home.css'

/* 首页与子页面共用的站点 header。home 模式下品牌区/下载按钮滚回顶部，
   子页面模式下改为跳转回首页。 */
function SiteHeader({ home = false }) {
    const { state } = useContext(Context)
    const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

    const brandInner = (
        <>
            <img src={state.appLogo} alt="上渔 App logo" />
            <img className="sy-brand__wordmark" src={wordmark} alt={state.appName} />
        </>
    )
    const btnStyle = { minHeight: 42, padding: '0 20px' }

    return (
        <header className="sy-header">
            <div className="sy-container sy-header__inner">
                {home ? (
                    <button className="sy-brand" onClick={toTop} aria-label="回到顶部">
                        {brandInner}
                    </button>
                ) : (
                    <a className="sy-brand" href="/" aria-label="返回首页">
                        {brandInner}
                    </a>
                )}
                <nav className="sy-nav">
                    <a className="sy-nav__link" href="/privacy">
                        隐私政策
                    </a>
                    <a className="sy-nav__link sy-nav__link--contact" href="/contact">
                        联系我们
                    </a>
                    {home ? (
                        <button className="sy-btn sy-btn--lime" onClick={toTop} style={btnStyle}>
                            下载 App
                        </button>
                    ) : (
                        <a className="sy-btn sy-btn--lime" href="/" style={btnStyle}>
                            下载 App
                        </a>
                    )}
                </nav>
            </div>
        </header>
    )
}

export default SiteHeader
